import december from './december.svg'
import blob from './blob.svg'

const images = {
  YEAR_END: december,
  blob
}

export default images